import React from "react";
import { Route, Redirect } from "react-router-dom";
import { empty, notUndefinedAndNull } from "../utils/Validation";
import { getSession } from "../services/Session";

/**
 * A public route component used for URLs which are accessiable publically only.
 *
 * If a logged in seession is found, user will be redirected to the dashboard of the application.
 */
const PublicRoute = ({ component: Component, title, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      empty(getSession()) === true ? getComponent(props,title,Component) : (
        <Redirect
          to={{
            pathname: "/app",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default PublicRoute;

function getComponent(props, title, Component){

  if(notUndefinedAndNull(title)){
    props.location.state = {
      ...props.location.state,
      pageTitle: title
    }
  }
  
  return <Component {...props} />
}

// PublicRoute.propTypes = {
//   path: PropTypes.string,
//   exact: PropTypes.bool,
//   component: PropTypes.element
// };
